import * as Scrivito from "scrivito";
import ImageOrVideo from "^/Components/ImageOrVideo";
import formatDate from "^/utils/formatDate";

function Story({ story }) {
  const date = story.get("publishFromDate");
  return (
    <Scrivito.LinkTag to={story} className="teaser-side-bar">
      <div className="teaser-side-bar__header">
        <ImageOrVideo widget={story} teaser={true} />
        <time
          className="teaser-side-bar__date"
          dateTime={date?.toISOString?.() ?? ""}
        >
          {formatDate(date, "DD.MM.YYYY")}
        </time>
      </div>
      <div className="teaser-side-bar__content">
        <h6 className="teaser-side-bar__title">{story.get("title")}</h6>
        <div
          className="teaser-side-bar__description"
          dangerouslySetInnerHTML={{ __html: story.get("description") }}
        />
      </div>
    </Scrivito.LinkTag>
  );
}
export default Scrivito.connect(Story);
